<template>
  <CustomModal
    :identifier="id"
    modal-dialog-classes="modal-xl modal-dialog-scrollable"
  >
    <template #header>
      <h2 class="fw-bolder">Express data entry</h2>
    </template>
    <template #header-close>
      <div
        class="btn btn-sm btn-icon btn-active-color-primary"
        data-bs-dismiss="modal"
        data-dismiss="modal"
      >
        <span class="svg-icon svg-icon-1">
          <inline-svg src="/media/icons/duotune/arrows/arr061.svg" />
        </span>
      </div>
    </template>
    <template #body>
      <div :id="`${id}-body`" class="row"></div>
    </template>
    <template #footer>
      <div class="row">
        <button
          class="btn btn-sm btn-primary btn-active-primary m-5"
          :id="`${id}-submit`"
          title="You could either enter the required details in the opened window or directly in the company/employee profiles"
        >
          Express data submit
        </button>
      </div>
    </template>
  </CustomModal>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import CustomModal from "@/components/modals/CustomModal.vue";

export default defineComponent({
  name: "company-express-data-modal",
  components: { CustomModal },
  data() {
    return {
      id: "company-express-data-entry",
    };
  },
});
</script>
